"use client";

import { usePathname } from "next/navigation";
import React, { ReactNode } from "react";

export function Container({ children }: { children: ReactNode }): JSX.Element {
  const pathname = usePathname();

  const paddingClass =
    pathname === "/about-us/corporate-solutions" ? "" : "px-5";

  return (
    <div
      className={`max-w-[1440px] mx-auto min-h-[65vh] ${paddingClass} lg:px-20`}
    >
      {children}
    </div>
  );
}
